/**
 * created by xcc on 2021/10/20
 * 新媒体信息组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Avatar, Card} from "antd";
import keepRecordIcon from './images/keepRecordIcon1.png';
import exclamatioMark from './images/exclamatioMark1.png';
import BaseComponent from "../../../../base/BaseComponent";

const {Meta} = Card;
export default class NewMediaInformation extends BaseComponent {
    static defaultProps = {
        title: '标题',
        customIconWidthHeight: 46,
        mark: 'xxx学院',
        dateMark: '',
        accountNumber: '731833645',
        iconUrl: '',
        bottomLeftMark: '历史发布',
        bottomRightMark: '转交媒体',
        customWidth: 324,
        colorType: 1,
        keepRecordIconShow: true,
    }
    static propTypes = {
        title: PropTypes.string.isRequired,//标题必传项
        iconUrl: PropTypes.string.isRequired,//左边图标部分，必传项
        mark: PropTypes.string.isRequired,//学院名称，必传项必传项
        dateMark: PropTypes.string.isRequired,//超过多长时间 必传项
        accountNumber: PropTypes.string,//账号必传项
        customIconWidthHeight: PropTypes.number,//图标的宽高大小一个字段可选字段 非必传字段
        onClickFunction: PropTypes.func,//点击每一项非必传项 ,点击上半部分 非必传字段
        onClickBottomLeftFunction: PropTypes.func,//点击底部按钮，非必传字段
        onClickBottomRightFunction: PropTypes.func,//点击底部按钮，非必传字段
        bottomLeftMark: PropTypes.string,//底部文字描述非必传项非必传字段
        bottomRightMark: PropTypes.string,//底部文字描述非必传项非必传字段
        customWidth: PropTypes.number,//自定义宽度非必传字段
        colorType: PropTypes.number,//颜色类型类型非必传字段 需要使用颜色，请看代码里面的值
        keepRecordIconShow: PropTypes.bool,//是否显示备案图标非必传字段
        defaultImg: PropTypes.string.isRequired,//默认图片


    }

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let colorType = this.props.colorType;
        let statusName = this.props.statusName === "已备案" ? "审核通过" : this.props.statusName;
        let needColor = '#999999';
        let statusNameColor = '#999999';
        switch (colorType) {
            case 0 :
                needColor = '#999999';
                break;
            case 1 :
                needColor = '#ff9933';
                break;
            case 2 :
                needColor = '#ff0000';
                break;
            case 3 :
                needColor = '#ffcc00';
                break;

        }
        if (statusName && statusName.indexOf("返回") > -1) {
            statusNameColor = '#78D21D';
        } else if (statusName && statusName.indexOf("提交至") > -1) {
            statusNameColor = '#02A7F0';
        }
        switch (statusName) {
            case "审核通过" :
                statusNameColor = '#008000';
                break;
            case "新增审核不通过" :
                statusNameColor = '#FF1313';
                break;
            case "更新审核不通过" :
                statusNameColor = '#FF1313';
                break;
            case "注销审核不通过" :
                statusNameColor = '#FF1313';
                break;
            case "删除审核不通过" :
                statusNameColor = '#FF1313';
                break;
            case "删除媒体" :
                statusNameColor = '#FF1313';
                break;
            case "已注销" :
                statusNameColor = '#FF1313';
                break;
        }

        //历史发布权限pms
        let historyPublishLimits = this.permissionCheck("pms:newsMediaManage:historyPublish");
        //转交媒体
        let transferLimits = this.permissionCheck("pms:newsMediaManage:transferMedia");
        return (
            <div className={'MediaInformation'}>
                <Card hoverable={true} style={{width: this.props.customWidth || "", height: 140, borderRadius: "5px"}}
                      >
                    <div style={{position: "relative", padding: "20px 20px 5px 20px"}} onClick={() => {
                        this.props.onClickFunction && this.props.onClickFunction()
                    }}>
                        <Meta
                            avatar={
                                <div style={{
                                    width: this.props.customIconWidthHeight,
                                    height: this.props.customIconWidthHeight,
                                    borderRadius: '5px'
                                }}>
                                   <span style={{
                                       color: statusNameColor,
                                       position: "absolute",
                                       right: "10px",
                                       top: "1px",
                                       fontSize: 12,
                                   }}>{statusName}</span>
                                    <img src={this.props.iconUrl ? this.props.iconUrl : this.props.defaultImg} style={{
                                        width: this.props.customIconWidthHeight,
                                        height: this.props.customIconWidthHeight,
                                        borderRadius: "50%",
                                        objectFit: "cover"
                                    }} alt=""/>
                                </div>
                            }
                            title={
                                <div style={{marginTop: 5}}>
                                    <span title={this.props.title} style={{
                                        fontSize: 14,
                                        verticalAlign: "middle",
                                        display: "inline-block",
                                        width: "auto",
                                        maxWidth: "149px",
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        color: "rgba(0, 0, 0, 0.85)",
                                        fontFamily: "Microsoft YaHei",
                                        fontWeight: "bold",
                                        opacity: 1
                                    }}>{this.props.title}</span>
                                    {
                                        this.props.keepRecordIconShow ?
                                            <img style={{width: 17, height: 17, marginLeft: 3, objectFit: "contain"}} src={keepRecordIcon}
                                                 alt=""/> :
                                            <img style={{width: 17, height: 17, marginLeft: 3, objectFit: "contain"}} src={exclamatioMark}
                                                 alt=""/>
                                    }
                                    {(this.props.statusName !== "已备案" && this.props.statusName !== "已注销") ?
                                        <span style={{
                                            fontSize: 12,
                                            verticalAlign: "middle",
                                            display: "inline-block",
                                            width: "30px",
                                            textAlign: "center",
                                            height: "18px",
                                            marginLeft: "2px",
                                            lineHeight: "14px",
                                            border: "1px solid #B684F2",
                                            borderColor: this.props.operateColor,
                                            background: this.props.operateBackgroundColor,
                                            borderRadius: "2px"
                                        }}><span style={{
                                            fontSize: "12px",
                                            fontFamily: "MicrosoftYaHei",
                                            color: this.props.operateColor,
                                            opacity: 1,
                                        }}>{this.props.operateType}</span></span> : null}
                                </div>

                            }
                            description={
                                <div style={{fontSize: 12}}>
                                    <div style={{display: 'flex', alignItems: "center"}}>
                                        <div style={{
                                            width: 100, overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            fontSize:12
                                        }} title={this.props.mainDeptName}>{this.props.mainDeptName}</div>
                                        <div style={{
                                            width: 100, overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            paddingLeft: "10px",
                                            fontSize:12
                                        }} title={this.props.leader}>{this.props.leader}</div>
                                    </div>
                                    <div style={{
                                        color: needColor, width: 200, overflow: 'hidden',
                                        textOverflow: 'ellipsis', height: 18,
                                        whiteSpace: 'nowrap', marginTop: 5
                                    }} title={this.props.dateMark}>{this.props.dateMark}</div>
                                </div>
                            }
                        />
                    </div>
                    <div style={{height: 1, background: 'rgba(0,0,0,0.1020)'}}/>
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        {historyPublishLimits ?
                            <div onClick={() => {
                                this.props.onClickBottomLeftFunction && this.props.onClickBottomLeftFunction()
                            }} style={{
                                height: 40,
                                lineHeight: '40px',
                                textAlign: 'center',
                                fontSize: 12,
                                color: '#666666'
                            }}>{this.props.bottomLeftMark}</div> : null}
                        <div style={{
                            width: 1,
                            height: 22,
                            lineHeight: '22px',
                            margin: "0px 50px",
                            border: "1px solid rgba(0,0,0,0.08)",
                            display: ((historyPublishLimits && transferLimits) && (this.props.createById === window.top.currentUser.id)) ? "block" : "none"
                        }}/>
                        {
                            (transferLimits && this.props.createById === window.top.currentUser.id) ?
                                <div onClick={() => {
                                    this.props.onClickBottomRightFunction && this.props.onClickBottomRightFunction()
                                }} style={{
                                    height: 40,
                                    lineHeight: '40px',
                                    textAlign: 'center',
                                    fontSize: 12,
                                    color: '#666666'
                                }}>{this.props.bottomRightMark}</div> : null}
                    </div>
                </Card>
                <style>{`.MediaInformation .ant-card-body{padding: 0;}`}</style>
            </div>
        )
    }

}